var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 25 24",
    width: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 22.5c-2.0767 0-4.10677-.6158-5.83348-1.7696-1.72672-1.1537-3.07253-2.7936-3.86725-4.7122s-1.00266-4.0298-.59751-6.06664c.40514-2.0368 1.40517-3.90773 2.87362-5.37618s3.33938-2.46848 5.37622-2.87362c2.0368-.40515 4.148-.19721 6.0666.59751s3.5585 2.14053 4.7122 3.86725c1.1538 1.72671 1.7696 3.75678 1.7696 5.83348 0 2.7848-1.1062 5.4555-3.0754 7.4246-1.9691 1.9692-4.6398 3.0754-7.4246 3.0754zm0-19.5c-1.78 0-3.52008.52785-5.00013 1.51678-1.48004.98893-2.63359 2.39454-3.31478 4.03907-.68119 1.64455-.85942 3.45415-.51215 5.19995.34726 1.7458 1.20443 3.3495 2.4631 4.6082 1.25868 1.2586 2.86232 2.1158 4.60816 2.4631 1.7458.3472 3.5554.169 5.2-.5122 1.6445-.6812 3.0501-1.8347 4.039-3.3148.989-1.48 1.5168-3.2201 1.5168-5.0001 0-2.38694-.9482-4.67613-2.636-6.36396-1.6879-1.68782-3.977-2.63604-6.364-2.63604z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9425 16.5-4.1925-4.1925v-7.0575h1.5v6.435l3.75 3.7575z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.7d4feadc37cc56bcf4306cba4c775f75.svg";
export { ForwardRef as ReactComponent };